import { checkContentHeight } from '../../pages/checkout/checkout.utils'

export class CardObserver {
    constructor() {}

    next(contentElement) {

        if(contentElement != null && contentElement != ""){
            if((contentElement.classList == 'card__content actived' || contentElement.classList == 'card__content') && (contentElement.classList == 'card__content actived' || contentElement.classList == 'card__content') != null){
            
                if(contentElement.parentElement){
                    contentElement.parentElement.classList.toggle('actived')
                }
                
                if(contentElement.previousElementSibling.querySelector('.expand-icon') != null){
                    contentElement.previousElementSibling.querySelector('.expand-icon').classList.toggle('actived')
                }
    
                if(contentElement.previousElementSibling.querySelector('.titulo') != null){
                    contentElement.previousElementSibling.querySelector('.titulo').classList.toggle('actived')
                }
                
                contentElement.classList.toggle('actived')
            }

            checkContentHeight();
        }
        
    }

    error(error) {

    }

    complete(){}
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/card/card.observer.js